<template>

  <div style="position: absolute;right: 6px;top:0px;height:100%;z-index: 999" :style="{width:width+'px'}">
    <div class="toolbar-hide-icon" @click="handlehideBar" v-if="toolbarHide">
        <svg-icon icon-class="yincangbukejian" style="font-size: 20px;"></svg-icon> 
      </div>
    <div class="toolbar-wrap" v-if="toolbarHide">
      
      <div style="width: 100%;text-align: center;font-size: 18px;height: 60px;line-height: 60px" class="title">操作
      </div>
        <div v-if="isBool" >
            <transition name="fade">
             <slot v-if="show"/>
            </transition>
        </div>
      <div class="icon" @click="handleChange">
            <svg-icon icon-class="1232" v-if="show&&isBool"></svg-icon>
            <svg-icon icon-class="1230" v-else></svg-icon>     
      </div>
    </div>

  </div>

</template>

<script>
    export default {
        name: "index",
        props: {
            value: {}, width: {
                default() {
                    return 210
                }
            }
        },
        data() {
            return {show: false,isBool:true,toolbarHide:true}
        },
        watch: {
            value(oldValue) {
                this.show = false;
                this.$nextTick(() => {
                    this.show = true;
                    this.toolbarHide = true;
                })
            }
        },
        methods:{
          handleChange(){
              this.isBool = !this.isBool;
              this.toolbarHide = true;
          },
          handlehideBar(){
            this.toolbarHide = false
          }
        },
    }
</script>

<style lang="scss" scoped>
    .toolbar-hide-icon{
      position: absolute;
      top: 21px;
      left: 17px;
      cursor: pointer;
      z-index: 1000;
    }
  .toolbar-wrap {
    // box-shadow: 0px 3px 20px rgba(8, 107, 175, 0.33);
    padding-bottom: 5px;
    position: sticky;
    right: 0px;
    top: 0;

    .title{
      [data-theme="theme1"] & {
        color:rgba(0,215,213,1);
      }
      [data-theme*="theme2"] & {
        color:rgb(153, 153, 153);
      }
    }

    [data-theme="theme1"] & {
      background:rgba(1,22,39,1);
      box-shadow:0px 3px 20px rgba(0,215,212,0.6);
    }
    [data-theme*="theme2"] & {
      background:#FFF;
      box-shadow: 0 3px 20px rgba(8,107,175,.33);
    }


    // background-color: #fff;

  }

  .fade-enter-active {
    transition: opacity 1.3s;
  }

  .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
    .icon{
      width: 100%;
      height: 20px;
      cursor: pointer;
      text-align: center;
      margin-top: -15px;
      .svg-icon{
        color: #086BAF;
        font-size: 28px;
        [data-theme="theme1"] &{
          color:rgba(0,215,213,1);
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/TableToolBar/index.vue